import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject, catchError, map, Observable, of, take } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PagesService {
  constructor(
    private readonly translocoService: TranslocoService,
    private readonly authService: AuthService,
  ) {}
  private readonly menuVisibleSubject = new BehaviorSubject<boolean>(false);

  menuVisible$ = this.menuVisibleSubject.asObservable();
  private readonly pages: any[] = [
    { id: 1, slug: 'chi-siamo', private: false },
    { id: 2, slug: 'come-funziona', private: false },
    { id: 3, slug: 'ricette', private: false },
    { id: 4, slug: 'contatti', private: false },
    { id: 5, slug: 'ricerca-prodotti', private: true, icon: 'pi-search' },
    { id: 6, slug: 'lista-della-spesa', private: true, icon: 'pi-list' },
    { id: 7, slug: 'wishlist', private: true, icon: 'pi-heart' },
    { id: 8, slug: 'le-mie-ricette', private: true, icon: 'icon-recipes' },
    { id: 9, slug: 'volantini', private: true, icon: 'pi-file' },
  ];

  getPages(): Observable<any[]> {
    return this.translocoService.selectTranslateObject('homepage.menuTop').pipe(
      map((translations) =>
        this.pages.map((page) => ({
          ...page,
          id: page.slug,
          label: translations[page.slug]?.replace(/-/g, ' ') || page.slug,
          url: translations[page.slug]?.toLowerCase() || `/${page.slug}`,
        })),
      ),
      catchError(() => of([])),
    );
  }

  getUserMenu(): Observable<MenuItem[]> {
    return this.translocoService.selectTranslateObject('homepage.menuTop').pipe(
      map((translations) => [
        {
          label: translations['profilo-utente'],
          routerLink: `/dashboard/${translations['profilo-utente']
            ?.replace(/ /g, '-')
            .toLowerCase()}`,
          private: true,
          routerLinkActiveOptions: { exact: true },
          command: () => {
            this.closingMenu();
          },
        },
        {
          label: translations['cambio-password'],
          routerLink: `/dashboard/${translations['profilo-utente']
            ?.replace(/ /g, '-')
            .toLowerCase()}/password`,
          private: true,
          routerLinkActiveOptions: { exact: true },
          command: () => {
            this.closingMenu();
          },
        },

        { label: translations['logout'], command: () => this.logOut(), private: true },
      ]),
      catchError(() => of([])),
    );
  }
  private closingMenu(): void {
    this.toggleMenu();
  }
  private logOut(): void {
    this.authService.logOut().pipe(take(1)).subscribe();
    document.body.classList.remove('no-scroll');
  }
  setMenuVisible(visible: boolean) {
    this.menuVisibleSubject.next(visible);
    document.body.classList.add('no-scroll');
  }

  toggleMenu() {
    this.menuVisibleSubject.next(!this.menuVisibleSubject.value);
    document.body.classList.remove('no-scroll');
  }
}
